import { type MinionOutput } from './types';

/**
 * Determines if the minion_outputs structure represents orchestration rounds.
 * Returns true if it's an array of arrays (rounds containing minions).
 */
export const isOrchestrationStructure = (minionOutputs: MinionOutput[] | undefined): boolean => {
	if (!Array.isArray(minionOutputs) || minionOutputs.length === 0) {
		return false;
	}
	// Check if first element is an array (indicating rounds structure)
	return Array.isArray(minionOutputs[0]);
};
